import Button from '../AppButton';
import { useThemeToken } from '@/hooks';
import { LuRefreshCw } from 'react-icons/lu';

type Props = {
  onRetry?: () => void;
  text: string;
};

export const TryAgain = ({ onRetry, text }: Props) => {
  const theme = useThemeToken();

  return (
    <div className="flex flex-col flex-fill center">
      <div className="color-error text-center">{text}</div>
      <div>
        <Button
          type="primary"
          onClick={onRetry}
          className="bg-color-green text-white mt-3 p-2"
          style={{ backgroundColor: theme.colorPrimary }}
        >
          <LuRefreshCw className="me-2 text-2xl" />
          دوباره تلاش کن
        </Button>
      </div>
    </div>
  );
};

TryAgain.defaultProps = {
  onRetry: () => { },
};

export default TryAgain;
